import { render, staticRenderFns } from "./AdminConsole.vue?vue&type=template&id=cb16338c&scoped=true&"
import script from "./AdminConsole.vue?vue&type=script&lang=js&"
export * from "./AdminConsole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb16338c",
  null
  
)

export default component.exports